"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _rcSteps = _interopRequireDefault(require("rc-steps"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Stepper');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "tick",
  size: "small",
  color: "white"
});

function Stepper(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      currentStep = _ref.currentStep,
      steps = _ref.steps,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "currentStep", "steps", "onClick"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Stepper.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, classNameProp);

  var stepClassNames = function stepClassNames(step, i) {
    var _classnames;

    return (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.completed, step.isCompleted), (0, _defineProperty2.default)(_classnames, classes.active, i === currentStep), _classnames));
  };

  var isHighlighted = function isHighlighted(step, i) {
    return step.isCompleted || i === currentStep;
  };

  function getIcon(i) {
    var content = i + 1;

    if (steps[i] && steps[i].isCompleted) {
      content = _ref2;
    }

    return /*#__PURE__*/_react.default.createElement("span", {
      onClick: isHighlighted(steps[i], i) ? function () {
        return onClick(i);
      } : undefined
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      className: classes.icon
    }, content));
  }

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, override.root), /*#__PURE__*/_react.default.createElement(_rcSteps.default, {
    current: currentStep
  }, steps.map(function (step, i) {
    return /*#__PURE__*/_react.default.createElement(_rcSteps.default.Step, {
      className: stepClassNames(step, i),
      key: i,
      icon: getIcon(i),
      title: /*#__PURE__*/_react.default.createElement("span", {
        onClick: isHighlighted(step, i) ? function () {
          return onClick(i);
        } : undefined
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: isHighlighted(step, i) ? 'bold' : undefined
      }, step.title))
    });
  })));
}

Stepper.overrides = ['root', 'rc-steps'];
Stepper.defaultProps = {
  steps: [],
  currentStep: 1
};
process.env.NODE_ENV !== "production" ? Stepper.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string
  })),
  currentStep: _propTypes.default.number,
  onClick: _propTypes.default.func
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Stepper);

exports.default = _default;